export const commerceCurrency = (o: any) => String(o.currencyCode || 'USD').toUpperCase();
export type CommerceType = 'wholesale' | 'online' | 'review';
export type CommerceScope = CommerceType | 'all';
export const COMMERCE_SCOPES: Array<{ value: CommerceScope; label: string }> = [
  { value: 'wholesale', label: 'Wholesale' }, { value: 'online', label: 'Online store' },
  { value: 'review', label: 'Needs review' }, { value: 'all', label: 'All orders' },
];
// Classify from order evidence, never a company name, address or basket size.
// An online-store origin does not rule out an untagged business purchase.
export function commerceType(o: any): CommerceType {
  if (o.source !== 'shopify') return 'wholesale';
  const data = o.sourceData || {};
  const tags = (Array.isArray(data.tags) ? data.tags : []).map((t: string) => String(t).trim().toLowerCase());
  if (['Faire', 'Airgoods'].includes(data.channel) || tags.includes('wholesale') || tags.includes('b2b') || data.purchasingEntityType === 'PurchasingCompany') return 'wholesale';
  if (data.sourceName === 'web' || data.sourceName === 'subscription_contract_checkout_one' || tags.includes('subscription')) return 'online';
  return 'review';
}
export function commerceEvidence(o: any): string {
  const type = commerceType(o), d = o.sourceData || {};
  if (o.source !== 'shopify') return 'Mise wholesale order';
  if (type === 'wholesale') return ['Faire', 'Airgoods'].includes(d.channel) ? `${d.channel} wholesale order` : d.purchasingEntityType === 'PurchasingCompany' ? 'Shopify B2B purchase' : 'Tagged wholesale in Shopify';
  if (type === 'online') return 'Online store or subscription';
  return 'No wholesale or online-store classification supplied';
}
export const inCommerceScope = (o: any, scope: CommerceScope) => scope === 'all' || commerceType(o) === scope;
export function commerceStage(o: any): string {
  if (o.status === 'cancelled') return 'Cancelled';
  const status = o.sourceData?.fulfillmentStatus;
  if (status === 'FULFILLED') return 'Fulfilled';
  if (status === 'PARTIALLY_FULFILLED') return 'Partially fulfilled';
  return 'To fulfill';
}
export function commerceFinance(orders: any[], currency: string) {
  const rows = orders.filter(o => o.source === 'shopify' && o.status !== 'cancelled' && commerceCurrency(o) === currency);
  const group = (key: (o: any) => string) => {
    const map = new Map<string, { label: string; orders: number; subtotal: number; beforeTax: number; tax: number; total: number; refunded: number }>();
    for (const o of rows) {
      const label = key(o), r = map.get(label) || { label, orders: 0, subtotal: 0, beforeTax: 0, tax: 0, total: 0, refunded: 0 };
      r.orders++; r.subtotal += o.subtotalCents; r.tax += o.sourceData?.taxCents || 0;
      r.beforeTax += o.totalCents - (o.sourceData?.taxCents || 0); r.total += o.totalCents; r.refunded += o.sourceData?.refundedCents || 0; map.set(label, r);
    }
    return [...map.values()].sort((a,b) => a.label.localeCompare(b.label));
  };
  return { rows, months: group(o => o.createdAt.slice(0, 7)), channels: group(o => o.sourceData?.channel || 'Shopify') };
}
